export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 UN CODE DÉFAUT… ET UNE PIÈCE CHANGÉE TROP VITE',
    body: 'Le scanner affiche un code, la pièce est remplacée, et la panne revient. Un code signale un circuit ou une plausibilité, pas une pièce à changer d’office.',
  },
  {
    title: '🔍 PAR OÙ COMMENCER ?',
    body: 'Ratés, ralenti instable, perte de puissance, voyant allumé : sans ordre de diagnostic, on teste au hasard et on perd du temps sur les mauvaises pistes.',
  },
  {
    title: '⚡ LES PANNES ÉLECTRIQUES INTERMITTENTES',
    body: 'Masses, faisceaux, connecteurs, réseau entre calculateurs : sans mesure au bon endroit, le défaut disparaît… puis revient.',
  },
  {
    title: '📚 DES INFORMATIONS DISPERSÉES PARTOUT',
    body: 'Cours, notes, forums, vidéos : l’information existe, mais jamais organisée au moment où le véhicule est sur le pont.',
  },
]
